import { Component, Input, OnDestroy } from '@angular/core';
import { FacilitySummary } from '../../../../../@core/domain/interfaces/facility-summary.interface';
import { Router } from '@angular/router';
import { StatusPageService } from '../../../services/status-page.service';

@Component({
  selector: 'app-facility-extended-full',
  templateUrl: './facility-extended-full.component.html',
  styleUrls: ['./facility-extended-full.component.scss'],
})
export class FacilityExtendedFullComponent implements OnDestroy {
  @Input()
  facilitySummary!: FacilitySummary;

  @Input()
  alertClass = 'custom-icon__facility';

  @Input()
  statusType!: string;

  constructor(private router: Router, private statusPageService: StatusPageService) {}

  gotoFacilityDetails(id: number): void {
    this.router.navigate(['/status/facilities/', id], { skipLocationChange: true });
  }

  notificationCounts() {
    return this.statusPageService.formatNotificationTooltip(this.facilitySummary, this.statusType);
  }

  ngOnDestroy(): void {}
}
